import React, { useState, useEffect } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Slide, Bounce, Fade } from 'react-awesome-reveal';
import { motion } from "framer-motion";
import AZ from '../../assets/logos/logo2.png';
// ...imports inchangés
import './GalerieSectionA.css'

const GalerieSectionA = () => {
  const images = [
 "img22/13.png",
    "img22/14.png",
    "img22/15.jpg",
    "img22/16.jpg",
    "img22/17.jpg",
    "img22/18.jpg",
    "img22/19.jpg",
    "img22/20.jpg",
    "img22/21.jpeg",
    "img22/22.jpg",
    "img22/23.jpg",
    "img22/24.jpg",
    "img22/25.jpg",

    "img22/1.jpg",
    "img22/2.webp",
    "img22/3.jpeg",
    "img22/4.webp",
    "img22/5.webp",
    "img22/6.webp",
    "img22/7.png",
    "img22/8.jpg",
    "img22/9.jpg",
    "img22/10.jpg",
    "img22/11.jpg",
    "img22/12.jpg",

   

   
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500); // simulate delay
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark">
        <motion.div
          className="spinner-border text-warning"
          role="status"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, repeat: Infinity, repeatType: 'mirror' }}
          style={{ width: "4rem", height: "4rem" }}
        />
      </div>
    );
  }

  return (
    <section className="bg1-pattern py-5" style={{ backgroundImage: 'url(images/assets/ban6.jpg)' }}>
      <Fade duration={800}>
        <div className="p-5">
          <div className="text-center mb-3">
            <Bounce>
              <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 400 }} />
            </Bounce>
          </div>

          <div className="text-center mb-4">
            <Slide direction="right">
              <h1 className="column-title text-warning" style={{ fontFamily: 'Times' }}>
                <b>GALERIE <hr /></b>
              </h1>
            </Slide>
           
          </div>

          <div className="scrollable-gallery-container">
  <div className="row g-3">
  {images.map((src, index) => (
  <motion.div
    key={index}
    className="col-6 col-sm-4 col-md-2 gallery-img-wrapper"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.05 }}
  >
    <motion.div
      className="gallery-img"
      whileHover={{ scale: 1.1, rotate: 1 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => {
        setPhotoIndex(index);
        setIsOpen(true);
      }}
    >
      <motion.img
        src={src}
        alt={`Gallery ${index + 1}`}
        className="img-fluid rounded-4"
        loading="lazy"
        animate={{
          y: [0, -5, 0],
        }}
        transition={{
          repeat: Infinity,
          duration: 4,
          ease: "easeInOut",
        }}
      />
      <div className="hover-glow"></div>
    </motion.div>
  </motion.div>
))}

  </div>
</div>


          {isOpen && (
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + images.length - 1) % images.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
              }
            />
          )}
        </div>
      </Fade>
    </section>
  );
};

export default GalerieSectionA;
